import Vue from 'vue'
import Vuikit from 'vuikit'
import VuikitIcons from '@vuikit/icons'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import '@vuikit/theme'

Vue.use(Vuikit)
Vue.use(VuikitIcons)
Vue.use(Vuetify)

const opts = {
}

export default new Vuetify(opts)
